<nav class="breadcrumb-container">
  @for (item of breadcrumbItems(); track item.label + $index) {
    <div class="breadcrumb-item" [class.active]="item.active">
      @if (!item.active) {
        <a class="breadcrumb-link" (click)="onBreadcrumbItemClick(item.index!)">
          @if (item.isHome) {
            <i class="fa-solid fa-house home-icon"></i>
          } @else {
            {{ item.label }}
          }
        </a>
      }
      @if (item.active) {
        <span>{{ item.label }}</span>
      }
      @if ($index < breadcrumbItems().length - 1) {
        <span class="breadcrumb-separator">/</span>
      }
    </div>
  }
</nav>